var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "开票上传",
        visible: _vm.dialogVisible,
        width: "600px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "invoice-info" },
            [
              _c("h4", [_vm._v("发票信息")]),
              _c(
                "el-descriptions",
                { attrs: { column: 2, border: "", size: "small" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "开票编码" } }, [
                    _vm._v(_vm._s(_vm.invoiceInfo.invoiceCode || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
                    _vm._v(_vm._s(_vm.invoiceInfo.orderNo || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "发票抬头" } }, [
                    _vm._v(_vm._s(_vm.invoiceInfo.invoiceTitle || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "开票金额" } }, [
                    _vm._v(
                      "¥" +
                        _vm._s(
                          Number(_vm.invoiceInfo.invoiceAmount || 0).toFixed(2)
                        )
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "开票类型" } },
                    [
                      _vm.invoiceInfo.invoiceType === 0
                        ? _c(
                            "el-tag",
                            { attrs: { type: "info", size: "mini" } },
                            [_vm._v("个人")]
                          )
                        : _vm.invoiceInfo.invoiceType === 1
                        ? _c(
                            "el-tag",
                            { attrs: { type: "success", size: "mini" } },
                            [_vm._v("企业")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "当前状态" } },
                    [
                      _vm.invoiceInfo.status === 0
                        ? _c(
                            "el-tag",
                            { attrs: { type: "info", size: "mini" } },
                            [_vm._v("申请中")]
                          )
                        : _vm.invoiceInfo.status === 1
                        ? _c(
                            "el-tag",
                            { attrs: { type: "success", size: "mini" } },
                            [_vm._v("已开票")]
                          )
                        : _vm.invoiceInfo.status === 2
                        ? _c(
                            "el-tag",
                            { attrs: { type: "danger", size: "mini" } },
                            [_vm._v("已拒绝")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "upload-section" },
            [
              _c("h4", [_vm._v("上传开票附件")]),
              _c("p", { staticClass: "tip" }, [
                _vm._v(
                  "请上传开票凭证，支持 PDF、DOC、DOCX、XLS、XLSX、JPG、PNG 格式，文件大小不超过 10MB"
                ),
              ]),
              _c("uploadFile", {
                attrs: { "skip-permi": "" },
                model: {
                  value: _vm.uploadedFileUrl,
                  callback: function ($$v) {
                    _vm.uploadedFileUrl = $$v
                  },
                  expression: "uploadedFileUrl",
                },
              }),
              _vm.uploadedFileUrl
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        color: "#67c23a",
                        "font-size": "12px",
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-check" }),
                      _vm._v(" 已上传成功 "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "remark-section" },
            [
              _c("h4", [_vm._v("备注")]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入备注信息（选填）",
                  rows: 3,
                  maxlength: "500",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.remark,
                  callback: function ($$v) {
                    _vm.remark = $$v
                  },
                  expression: "remark",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.loading },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm.invoiceInfo.status === 0
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    loading: _vm.loading,
                    disabled: _vm.loading,
                  },
                  on: { click: _vm.rejectInvoice },
                },
                [_vm._v("拒绝开票")]
              )
            : _vm._e(),
          _vm.invoiceInfo.status === 0
            ? _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loading,
                    disabled: !_vm.uploadedFileUrl || _vm.loading,
                  },
                  on: { click: _vm.confirmInvoice },
                },
                [_vm._v("确认开票")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }